import { defineStore } from "pinia";
import { ref, computed, watch } from "vue";

export const useThemeStore = defineStore("theme", () => {
  const _isDark = ref(localStorage.getItem("dark") === "true");
  const _forcedDark = ref(false);

  // true se o usuário prefere escuro OU se a rota atual força modo escuro
  const isDark = computed(() => _isDark.value || _forcedDark.value);

  const applyTheme = () => {
    document.body.classList.toggle("dark", isDark.value);
    // Persiste apenas a preferência real do usuário, não o estado forçado pela rota
    localStorage.setItem("dark", String(_isDark.value));
  };

  const toggle = () => {
    _isDark.value = !_isDark.value;
  };

  const forceDark = () => {
    _forcedDark.value = true;
  };

  const clearForceDark = () => {
    _forcedDark.value = false;
  };

  // Item "dark" localstorage passa a ser reativo.
  watch(isDark, applyTheme, { immediate: true });

  return {
    isDark,
    toggle,
    forceDark,
    clearForceDark,
  };
});
